/**
 * Inputs settings to generate atomic classes.
 *
 * WARNING!!! `key` are required.
 * Other are used in iCMS
 */
const input = [
    // default from atomic
    // ...atomic.component,
    // custom local
    { key: 'input', title: 'Default' }
];
exports.input = input;
